export default {
    load: false,
    type: 'Custom',
    col: 10,
    columns: [],
    heightFixed: false,
    height: 400,
    defaultFilter: '',
    search: false,
    filters:[],
    reopenPayToAgreement: true,
    opened:{
        searchAdd: false,
        searchEdit: false,
        list:[
            {
                label: 'Поиск',
                type: 'label',
                field: '1'
            },
            {
                label: 'Добавление платежа',
                type: 'switch',
                field: 'searchAdd'
            },
            {
                label: 'Редактирование платежа',
                type: 'switch',
                field: 'searchEdit'
            },
        ],
    },
    data: null,


    filter: '',
    visible: false,
    rebind: true,
    addFields: []
}